export default {
    SUPERADMIN: 'ef8cc458-4e0d-428e-b40a-051d99a5c37c',
    ADMIN: '71c1e3e3-5a4e-4f83-8a2c-33e73eda25e4',
    PHARMACIST: '1fca7e65-203e-4159-bc32-cb3044a4054f',
    TECHNICIAN: 'ea116f7f-4739-4477-9589-76ebc39683c2',
    STOCKER: 'f4b562f0-ba95-435e-9212-49e5d7868b22',
    DELIVERYTECH: '801815fc-9e44-479b-b7c1-fe3ba1445808',
  };


// WEBPACK FOOTER //
// ./src/components/common/userroles.js